import React, { useState } from 'react'
import {Button, Chip, Stack, styled, TextareaAutosize, Typography, Box} from "@mui/material";
import LanguageSelector from "./LanguageSelector";
import { useTranslation } from 'react-i18next';
import { currentTheme } from "../../theme/ThemeUtils.js";

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

export default function Descriptions({ descriptions, setDescriptions, currentDescription, setCurrentDescription,
                                         currentDescriptionLang, setCurrentDescriptionLang,
                                         currentDescriptionName, setCurrentDescriptionName}) {

    const { t } = useTranslation();
    const [editing, setEditing] = useState(false)

    const handleDescriptionClick = (descToEdit) => () => {
        setCurrentDescription(descToEdit.description)
        setCurrentDescriptionLang(descToEdit.language)
        setCurrentDescriptionName(descToEdit.name)
        setEditing(true)
    }

    const handleDescriptionDelete = (descToDelete) => () => {
        setDescriptions((descs) => descs.filter((desc) => desc.language !== descToDelete.language));
    };

    const addDescription = () => {
        const newDescription = {
            language: currentDescriptionLang,
            description: currentDescription,
            name: currentDescriptionName
        }
        let newDescriptions = descriptions
            ? descriptions.filter(d => d.language !== currentDescriptionLang)
            : []
        newDescriptions = [...newDescriptions, newDescription]
        setDescriptions(newDescriptions)
        setEditing(true)
    };

    const handleLanguageChange = (langCode, langName) => {
        setEditing(descriptions && descriptions.filter(d => d.language === langCode).length > 0)
        setCurrentDescriptionLang(langCode);
        setCurrentDescriptionName(langName);
    }

    return (
        <Stack spacing={1}>
            <Typography variant="subtitle1">{ t("details.descriptions.title") }</Typography>
            <LanguageSelector
                language={ currentDescriptionLang }
                handleLanguageChange={ (langCode, langName) => handleLanguageChange(langCode, langName) }
                textLabel={ t("details.descriptions.language") }
            />
            <TextareaAutosize
                minRows={2}
                maxRows={4}
                aria-label={ t("details.descriptions.aria-label." + currentTheme()) }
                placeholder={ t("details.descriptions.placeholder." + currentTheme()) }
                value={ currentDescription || "" }
                onChange={ (e) => setCurrentDescription(e.target.value) }
            />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={ addDescription }
                    disabled={ !(currentDescription && currentDescriptionLang) }
                >
                    { editing ? t("details.descriptions.update") : t("details.descriptions.add") }
                </Button>
            </Box>
            { descriptions ?
            <Stack direction="row"
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    listStyle: 'none',
                    p: 0.5,
                    m: 0,
                }}
                component="ul"
            >
                {descriptions.map((data, index) => {

                    return (
                        <ListItem key={index}>
                            <Chip
                                label={data.language}
                                onClick={ handleDescriptionClick(data) }
                                onDelete={ handleDescriptionDelete(data) }
                                size="small"
                            />
                        </ListItem>
                    );
                })}
            </Stack>
            : null}
        </Stack>
    );
}